<template>
  <v-container id="horarios" fluid tag="section">
    <base-material-card class="px-5 py-3">
      <template v-slot:heading>
        <v-tabs
          v-model="tabs"
          background-color="transparent"
          slider-color="white"
        >
          <v-tab class="mr-3">
            <v-icon class="mr-2">mdi-bug</v-icon>Tipos
          </v-tab>
          <v-tab class="mr-3">
            <v-icon class="mr-2">mdi-code-tags</v-icon>Semana
          </v-tab>
          <v-tab> <v-icon class="mr-2">mdi-cloud</v-icon>Año </v-tab>
          <v-spacer />
          <v-select
            :items="modoHorarios"
            v-model="modoDomicilio"
            label="¿Forzado Domicilio?"
          />
          <v-spacer />
          <v-select
            :items="modoHorarios"
            v-model="modoRecoger"
            label="¿Forzado Recoger?"
          />
          <v-spacer />
          <v-select
            :items="modoHorarios"
            v-model="modoApertura"
            label="¿Forzado Apertura?"
          />
          <v-spacer />
          <v-btn color="primary" @click="saveTodo" :loading="loadingSave"
            >GUARDAR TODO</v-btn
          >
        </v-tabs>
      </template>

      <v-tabs-items v-model="tabs" class="transparent">
        <v-tab-item key="1">
          <v-card-actions>
            <v-btn color="primary" @click="addTipo" text>Añadir tipo</v-btn>
          </v-card-actions>
          <v-row>
            <v-col cols="6" v-for="(t, i) in horarios.tipos" :key="i">
              <v-card outlined color="lighten-3">
                <v-row>
                  <v-card-title>Tipo {{ t.nombre }}</v-card-title>
                  <v-card-actions>
                    <v-btn text @click="removeTipo(i)">Eliminar Tipo</v-btn>
                  </v-card-actions>
                </v-row>
                <v-card-text class="text--primary">
                  <v-text-field
                    v-model="t.nombre"
                    label="nombre"
                  ></v-text-field>
                  <v-btn @click="addRango(i)" text color="secondary"
                    >Añadir Rango</v-btn
                  >
                </v-card-text>
                <v-row v-for="(r, j) in t.rangos" :key="j">
                  <v-col cols="4">
                    <v-menu
                      ref="menu"
                      v-model="r.mostrar"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="s"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="r.inicio"
                          label="Inicio"
                          prepend-icon="mdi-access_time"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="r.mostrar"
                        v-model="r.inicio"
                        full-width
                        @click:minute="$refs.menu.save(r.inicio)"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="4">
                    <v-menu
                      ref="menu"
                      v-model="r.mostrarFin"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="s"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="r.fin"
                          label="Fin"
                          prepend-icon="mdi-access_time"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="r.mostrarFin"
                        v-model="r.fin"
                        full-width
                        @click:minute="$refs.menu.save(r.fin)"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="1">
                    <v-btn color="red" text @click="removeRango(i, j)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item key="2">
          <v-card-text>
            <v-row>
              <v-col cols="3" v-for="(d, i) in diasSemana" :key="d.value">
                <span>{{ d.text }}</span>
                <v-select
                  v-model="horarios.semana[i].recoger"
                  :items="selectTipos"
                  label="Recoger"
                />
                <v-select
                  v-model="horarios.semana[i].domicilio"
                  :items="selectTipos"
                  label="Domicilio"
                />
                <v-select
                  v-model="horarios.semana[i].apertura"
                  :items="selectTipos"
                  label="Apertura"
                />
                <v-select
                  v-if="aceptaReservas"
                  v-model="horarios.semana[i].reserva"
                  :items="selectTipos"
                  label="Reservas"
                />
              </v-col>
            </v-row>
            <v-row dense v-if="aceptaReservas">
              <v-col cols="12">
                <v-alert color="info">
                  <v-btn @click="goReservas" text>
                    Ir a configuración de reservas</v-btn
                  >
                </v-alert>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>
        <v-tab-item key="3">
          <v-card-text>AÑO</v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </base-material-card>
  </v-container>
</template>

<script>
import { restSinNegocio } from "@/utils/restaurantes.utils.js";

import { mapState, mapGetters } from "vuex";
var _ = require("lodash");
export default {
  data() {
    return {
      tabs: 0,
      horarios: {},
      loadingSave: false,
      s: "",
      modoDomicilio: "auto",
      modoRecoger: "auto",
      modoApertura: "auto",
    };
  },
  computed: {
    aceptaReservas() {
      return this.restGest.confGeneral
        ? this.restGest.confGeneral.aceptaReserva
        : false;
    },
    ...mapGetters({
      restGest: "app/restGestObj",
      negocio: "app/negocioGestObj",
    }),
    ...mapState({
      diasSemana: (state) => state.negocios.diasSemana,
      modoHorarios: (state) => state.negocios.modoHorarios,
    }),
    selectTipos() {
      var res = [];
      res.push({
        value: null,
        text: "Cerrado",
      });

      if (Array.isArray(this.horarios.tipos)) {
        this.horarios.tipos.forEach((t) => {
          let aux = {
            value: t.nombre,
            text: t.nombre,
          };
          res.push(aux);
        });
      }
      return res;
    },
  },
  methods: {
    goReservas() {
      let str =
        "/admin/gest/" +
        this.negocio.id +
        "/restaurantes/" +
        restSinNegocio(this.restGest) +
        "/reservas";
      this.$router.push(str);
    },
    addTipo() {
      let aux = {
        nombre: "nuevo rango",
        rangos: [
          {
            inicio: "08:15",
            fin: "14:00",
          },
          {
            inicio: "16:15",
            fin: "20:00",
          },
        ],
      };
      this.horarios.tipos.push(aux);
      this.$forceUpdate();
    },
    removeTipo(i) {
      _.pullAt(this.horarios.tipos, i);
      this.$forceUpdate();
    },
    removeRango(i, j) {
      let rangos = JSON.parse(JSON.stringify(this.horarios.tipos[i].rangos));
      _.pullAt(rangos, j);
      this.horarios.tipos[i].rangos = rangos;
      this.$forceUpdate();
    },
    addRango(i) {
      let aux = {
        inicio: "08:15",
        fin: "14:00",
      };
      this.$forceUpdate();
      this.horarios.tipos[i].rangos.push(aux);
    },
    saveTodo() {
      this.loadingSave = true;
      let _vm = this;

      return this.$store
        .dispatch("restaurantes/saveHorarios", {
          horarios: this.horarios,
          modoHorarioDomicilio: this.modoDomicilio,
          modoHorarioRecoger: this.modoRecoger,
          modoHorarioApertura: this.modoApertura,
        })
        .then((r) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Horarios guardados",
          });
        })
        .catch((e) => {
          console.log(e);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar los horarios",
          });
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
  },
  beforeMount() {
    if (
      this.restGest.horarios &&
      this.restGest.horarios.semana[0].hasOwnProperty("recoger")
    ) {
      this.horarios = this.restGest.horarios;
      this.modoDomicilio = this.restGest.modoHorarioDomicilio
        ? this.restGest.modoHorarioDomicilio
        : "auto";
      this.modoRecoger = this.restGest.modoHorarioRecoger
        ? this.restGest.modoHorarioRecoger
        : "auto";
      this.modoApertura = this.restGest.modoHorarioApertura
        ? this.restGest.modoHorarioApertura
        : "auto";
    } else {
      this.horarios = {
        tipos: [],
        semana: [
          {
            recoger: null,
            domicilio: null,
            apertura: null,
          },
          {
            recoger: null,
            domicilio: null,
            apertura: null,
          },
          {
            recoger: null,
            domicilio: null,
            apertura: null,
          },
          {
            recoger: null,
            domicilio: null,
            apertura: null,
          },
          {
            recoger: null,
            domicilio: null,
            apertura: null,
          },
          {
            recoger: null,
            domicilio: null,
            apertura: null,
          },
          {
            recoger: null,
            domicilio: null,
            apertura: null,
          },
        ],
        year: [],
      };
    }
  },
  mounted() {},
};
</script>

<style>
</style>